import React from "react";
import { motion } from "framer-motion";
import grapesImg from "../../assets/grapes-sketch.png";
import wineGlassSketch from "../../assets/wine-glass-sketch.png";
import beerGlassCardImg from '../../assets/wine-cards-glass.png'
import beerDark from "../../assets/wine-bottle.png";
import beerLight from "../../assets/wine-bottle.png";
import beerBottle from "../../assets/wine-bottle.png";
import mangoWineImg from '../../assets/mango-wine.png';
import beetrootWineImg from '../../assets/beetroot-wine.png';
import blackGrapeWineImg from '../../assets/black-grapes-wine.png';
import chikkuWineImg from '../../assets/chikku-wine.png';
import gingerWineImg from '../../assets/ginger-wine.png';
import greenGrapeWineImg from '../../assets/green-grapes-wine.png';
import jamunWineImg from '../../assets/jamun-wine.png';
import pineappleWineImg from '../../assets/pineapple-wine.png';
import raisinsWineImg from '../../assets/kishmish-wine.png';
import watermelonWineImg from '../../assets/watermelon-wine.png';
import whiteJamunWineImg from '../../assets/white-jamun.png'

export const homemadeWines = [
  {
    image: mangoWineImg,
    name: "Mango Wine (Totapuri)",
    ingredients: ["Totapuri mango water", "wheat", "sugar", "Herbal Tea"],
    twist: "Herbal Tea adds a hint of caramel and spice",
    fermentation: "Natural sugars from mango and added sugar are converted to alcohol by yeast",
    tasting: ["Balanced acidity", "Fruity aroma", "Well-balanced", "Bold and fruity"],
    flavors: ["Ripe mango", "Spicy herbal tea", "Sweet", "Grainy texture from wheat"],
    serving: {
      temp: "Chilled",
      pairsWith: ["Light appetizers", "Tropical fruits", "Spicy dishes"],
    },
  },
  {
    image: beetrootWineImg,
    name: "Beetroot Wine",
    ingredients: ["Fresh beetroot water", "kishmish", "wheat", "sugar", "Herbal Tea"],
    twist: "Herbal Tea adds caramel and spice notes",
    fermentation: "Natural sugars from beetroot and added sugar fermented by yeast",
    tasting: ["Balanced acidity", "Earthy aroma", "Smooth and balanced", "Bold and earthy"],
    flavors: ["Earthy beetroot", "Spicy tea", "Sweet raisins", "Grainy wheat texture"],
    serving: {
      temp: "Chilled",
      pairsWith: ["Hearty salads", "Roasted vegetables", "Mild cheeses"],
    },
  },
  {
    image: blackGrapeWineImg,
    name: "Black Grape Wine",
    ingredients: ["Black grape water", "wheat", "sugar", "Herbal Tea"],
    twist: "Herbal Tea adds caramel and spice notes",
    fermentation: "Natural and added sugars converted by yeast",
    tasting: ["Balanced acidity", "Fruity aroma", "Well-balanced", "Bold and fruity"],
    flavors: ["Black grapes", "Spicy tea", "Sweet", "Wheat texture"],
    serving: {
      temp: "Chilled",
      pairsWith: ["Dark chocolate", "Grilled meats", "Strong cheeses"],
    },
  },
];

const fadeInUp = {
  hidden: { opacity: 0, y: 30 },
  visible: { opacity: 1, y: 0 },
};

const BeerPricing = () => {
  return (
    <motion.div
      className="beer-pricing-section"
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true }}
      transition={{ staggerChildren: 0.2 }}
    >
      {/* Top Grapes BG */}
      <motion.img
        src={grapesImg}
        alt=""
        className="absolute top-0 -right-0 opacity-10 w-[200px]"
        initial={{ opacity: 0, x: 30 }}
        whileInView={{ opacity: 0.1, x: 0 }}
        transition={{ duration: 0.7 }}
        viewport={{ once: true }}
      />

      {/* Bottom Wine Sketch */}
      <motion.div
        className="absolute bottom-0 left-0 opacity-20"
        initial={{ opacity: 0, x: 30 }}
        whileInView={{ opacity: 0.05, x: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.7 }}
      >
        <img src={wineGlassSketch} alt="" className="w-[200px]" />
      </motion.div>

      <motion.div className="beer-pricing-inner-section" variants={fadeInUp}>
        <motion.h2
          className="text-4xl sm:text-5xl font-extrabold text-[--primary-wine] leading-tight text-center mb-8 relative z-10"
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.7 }}
        >
          <span className="text-[--neutral-black]">Wine </span>
          <span className="relative inline-block text-[--neutral-black]">
            Journey
            <span className="absolute bottom-1 left-0 w-full h-[6px] bg-[--accent-gold] -z-10 rounded-md"></span>
          </span>
        </motion.h2>

        <motion.div
          className="beer-pricing-cards"
          variants={fadeInUp}
          transition={{ staggerChildren: 0.2 }}
        >
          {homemadeWines.map((item, index) => (
            <motion.div
              className="beer-pricing-card"
              key={index}
              variants={fadeInUp}
              transition={{ duration: 0.6, delay: index * 0.1 }}
            >
              <motion.img
                src={item.image}
                alt=""
                className="beer-pricing-card-img"
                transition={{ type: "spring", stiffness: 100 }}
              />
              <motion.div className="beer-pricing-content" variants={fadeInUp}>
                <motion.h1 variants={fadeInUp}>{item.name}</motion.h1>
                <motion.ul variants={fadeInUp}>
                  {item.tasting.map((tastingNote, idx) => (
                    <motion.li key={idx} variants={fadeInUp}>
                      {tastingNote}
                    </motion.li>
                  ))}
                </motion.ul>
                <motion.button
                  className="beer-pricing-contact-button"
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  transition={{ type: "spring", stiffness: 120 }}
                  onClick={() => {
                    const message = `Hi, I'm interested in learning more about your ${item.name}. Please share the details.`;
                    const phone = "919881055454"; // ✅ replace with your WhatsApp number (without + sign)
                    const whatsappURL = `https://wa.me/${phone}?text=${encodeURIComponent(message)}`;
                    window.open(whatsappURL, "_blank");
                  }}
                >
                  Know More
                </motion.button>
              </motion.div>
              <img
                src={beerGlassCardImg}
                alt=""
                className="absolute top-1/2 right-0  -translate-y-1/2 opacity-10 w-full object-contain"
              />
            </motion.div>
          ))}
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default BeerPricing;
